<template>
  <div class="set-email">
    <van-nav-bar
      :title="lang.joinEmail"
      :left-arrow="!$route.query.fromapp"
      @click-left="$router.go(-1)"
    />
    <!-- 验证成功 -->
    <div
      v-if="isSuccess"
      class="success"
    >
      <div class="login-icon">
        <svg
          slot="title"
          class="icon-logo"
          aria-hidden="true"
        >
          <use xlink:href="#icon-logo" />
        </svg>
      </div>
      <p>
        <span><van-icon name="success" /></span>{{ lang.joinSuccess }}
      </p>
      <van-button
        type="danger"
        size="large"
        @click="$router.push('/')"
      >
        {{ lang.backHome }}
      </van-button>
    </div>
    <div v-else>
      <div v-if="!isSend">
        <div class="main">
          <input
            v-model="value"
            type="text"
            :placeholder="lang.emailAddress"
          >
        </div>
        <div class="btn-sub">
          <van-button
            :disabled="value ? false : true"
            type="danger"
            size="large"
            @click="clickEdit"
          >
            {{ lang.confirm1 }}
          </van-button>
        </div>
      </div>
      <!-- 提交后 -->
      <div
        v-else
        class="send"
      >
        <div class="login-icon">
          <svg
            slot="title"
            class="icon-logo"
            aria-hidden="true"
          >
            <use xlink:href="#icon-logo" />
          </svg>
        </div>
        <div class="content">
          <span><van-icon name="success" /></span>
          {{ lang.sendEmail }}
        </div>
        <van-button
          type="danger"
          size="large"
          @click="$router.go(-1)"
        >
          {{ lang.confirm1 }}
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import lang from './../../../common/language/editUser';
export default {
  data() {
    return {
      lang: lang,
      isSuccess: false,
      isSend: false,
      value: '',
      cid: '',
      userInfo: ''
    };
  },
  created() {
    /**绑定邮箱 */
    if (this.$route.query.cid) {
      if (document.body.clientWidth >= 992) {location.href = this.pub.config.pcPushUrl + `my/set-email?cid=${this.$route.query.cid}`;}
      else
        {this.axios
          .post(this.pub.getApi().BindEmail, {
            cid: this.$route.query.cid
          })
          .then(res => {
            if (res.data.code == 0) {
              this.isSuccess = true;
            } else if (res.data.code == 1308) {
              this.$notify(lang.emailRegistered);
            }
          });}
    }
  },
  methods: {
    /**点击发送验证邮件 */
    clickEdit() {
      if (/^[a-zA-Z0-9]+([\.a-zA-Z0-9_-]*)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.value)) {
        this.axios
          .post(this.pub.getApi().PreBindEmail, {
            email: this.value
          })
          .then(res => {
            if (res.data.code == 0) {
              this.isSend = true;
            } else if (res.data.code == 1308) {
              this.$notify(lang.emailRegistered);
            }
          });
      } else {
        this.$notify(lang.emailError);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.set-email {
  .main {
    padding: 33px 26px;
    overflow: hidden;
    input {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      outline: none;
      border: none;
      border-bottom: 1px solid #eee;
      padding: 0 2px;
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 15px;
    }
  }
  .btn-sub {
    padding: 0 26px;
    p {
      line-height: 50px;
      color: #b2b2b2;
      font-size: 14px;
    }
  }
  .success {
    .login-icon {
      margin-top: 22px;
      .icon-logo {
        height: 100px;
      }
    }
    p {
      font-size: 20px;
      line-height: 48px;
      color: #333;
      padding: 32px 0 24px 0;
      span {
        margin-right: 6px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: #4cd964;
        display: inline-block;
        vertical-align: middle;
        .van-icon-success {
          color: #fff;
          font-size: 26px;
          line-height: 48px;
        }
      }
    }
    padding: 0 26px;
  }
  .send {
    padding: 0 26px;
    .content {
      font-size: 20px;
      line-height: 48px;
      color: #333;
      padding: 32px 0 24px 0;
      text-align: left;
      span {
        text-align: center;
        margin-right: 6px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: #4cd964;
        display: inline-block;
        vertical-align: middle;
        .van-icon-success {
          color: #fff;
          font-size: 26px;
          line-height: 48px;
        }
      }
    }
  }
}
</style>
